import type { ComponentType, SVGProps } from 'react';
import { CalendarCheck02, Copy01, CreditCard01, HomeLine, LineChartUp02, UserPlus01, Users01 } from '@untitledui/icons';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export interface NavigationItem {
  label: string;
  path: string;
  icon: IconComponent;
  mobile: boolean;
  group: 'Overview' | 'Manage';
  matchPrefixes?: string[];
}

export const navigationItems: NavigationItem[] = [
  { label: 'Dashboard', path: '/dashboard', icon: HomeLine, mobile: true, group: 'Overview', matchPrefixes: ['/dashboard'] },
  { label: 'Members', path: '/members', icon: Users01, mobile: true, group: 'Overview', matchPrefixes: ['/members'] },
  { label: 'Attendance', path: '/attendance/dashboard', icon: CalendarCheck02, mobile: true, group: 'Overview', matchPrefixes: ['/attendance'] },
  { label: 'Payments', path: '/payments/dashboard', icon: CreditCard01, mobile: true, group: 'Overview', matchPrefixes: ['/payments'] },
  { label: 'Payment analytics', path: '/payments/analytics', icon: LineChartUp02, mobile: false, group: 'Overview', matchPrefixes: ['/payments/analytics'] },
  { label: 'Finance', path: '/finance', icon: CreditCard01, mobile: true, group: 'Overview' },
  { label: 'Register member', path: '/register', icon: UserPlus01, mobile: true, group: 'Manage', matchPrefixes: ['/register', '/assessment'] },
  { label: 'Copy workouts', path: '/copy-workouts', icon: Copy01, mobile: false, group: 'Manage', matchPrefixes: ['/copy-workouts'] }
];

export const isNavigationItemActive = (pathname: string, item: NavigationItem) =>
  !(pathname.startsWith('/payments/analytics') && item.path === '/payments/dashboard') &&
  (item.matchPrefixes || [item.path]).some(prefix => pathname.startsWith(prefix));

export const getPageTitle = (pathname: string) => {
  if (pathname.startsWith('/workout-plan')) return 'Workout plan';
  if (pathname.includes('/measurements')) return 'Body measurements';
  if (pathname.includes('/edit')) return 'Edit member';
  if (pathname === '/payments') return 'Record payment';
  const item = navigationItems.find(navigationItem => isNavigationItemActive(pathname, navigationItem));
  return item?.label || 'Cenadz Fitness';
};
